
import { useLocation } from 'react-router-dom';
import { useEffect, useRef } from 'react';

import CloseFooter from './CloseFooter';
import EntityInfo from './EntityInfo';

import Drawer from '@mui/material/Drawer';

const EntityInfoDrawer = ({ speakerId, open, onClose, backLabel }) => {
    const { state, key } = useLocation();
    const previousEntryRef = useRef(null);
    const onCloseRef = useRef(onClose);

    useEffect(() => {
        onCloseRef.current = onClose;
    }, [onClose]);

    useEffect(() => {
        if (state?.closeAllModal) {
            onCloseRef.current();
        }
    }, [state]);

    useEffect(() => {
        // A new route owns its URL; dismissing the old drawer must not replace it.
        if (previousEntryRef.current && previousEntryRef.current.key !== key) {
            previousEntryRef.current = null;
            return;
        }
        if (open) {
            if (!previousEntryRef.current) {
                previousEntryRef.current = {
                    key,
                    url: `${window.location.pathname}${window.location.search}${window.location.hash}`,
                };
            }
            window.history.replaceState(window.history.state, '', `/speaker/${speakerId}`);
            return;
        }

        if (previousEntryRef.current) {
            window.history.replaceState(window.history.state, '', previousEntryRef.current.url);
            previousEntryRef.current = null;
        }
    }, [open, speakerId, key]);

    return (
        <Drawer
            anchor='bottom' open={open} onClose={onClose}>
            <div className='horizontalCenter appScreen appDrawerSurface' style={{ minHeight: 'var(--app-height, 100svh)' }}>
                <div className='hasCloseFooter'>
                    <EntityInfo speakerId={speakerId} persistQueryInUrl={false} />
                    <CloseFooter onClick={onClose} optText={backLabel} />
                </div>
            </div>
        </Drawer>
    );
};

export default EntityInfoDrawer;
